import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'

import Amenities from '../components/Amenities'
import Readmore from '../components/Readmore'
import InfoPanelContent from '../components/InfoPanelContent'
import InfoPanelQuadhashSummary from './InfoPanelQuadhashSummary'
import InfoPanelQuadhashActions from './InfoPanelQuadhashActions'


import {
  useWaypoint,
  useRoute,
  useWaypointAmenities,
  addDefaultArgs
} from '../api'

import {
  useReservationActions
} from '../hooks'

import { setPermentMapPin } from '../slices/map'

const WaypointInfo = (props) => {
  const { quadhash, route_id, trail_id } = props
  const dispach = useDispatch()
  const { trails } = useRoute({routeId:route_id}) || {}
  const waypoint = useWaypoint({ quadhash: quadhash })
  const { title, subtitle, images, description, amenities, uuid, lnglat, elevation } = waypoint || {}
  const icons = amenities && Object.keys(amenities)
  const isStopPoint = (trails && trail_id === trails.length) || (amenities && "accommodation" in amenities)
  const baseActions = useReservationActions([
    route_id, 
    trail_id, {
      type: 'waypoint',
      quadhash: quadhash
    }
  ],{skip: !waypoint?.quadhash || !waypoint?.is_bookable || waypoint?.amenities['accommodation'] <= 1})
  const summary = <InfoPanelQuadhashSummary quadhash={quadhash} 
                                                        icons={icons} 
                                                        elevation={elevation} 
                                                        route_id={route_id} 
                                                        trail_id={trail_id} />
  const actions = <InfoPanelQuadhashActions quadhash={quadhash} 
                                                        route_id={route_id} 
                                                        trail_id={trail_id} 
                                                        actions={baseActions}
                                                        isStopPoint={isStopPoint} />
  const useAmenities = addDefaultArgs(useWaypointAmenities, { quadhash: quadhash })

  useEffect(() => {
    if (lnglat) {
      dispach(setPermentMapPin(lnglat))
    }
    return () => {
      dispach(setPermentMapPin(null))
    }
  }, [lnglat, dispach])

  return (
    <InfoPanelContent title={title}
                      subtitle={subtitle}
                      images={images}
                      summary={summary}>

      { description && (
        <Readmore maxHeight={200}>
          <div className="pwa__infopanel__descriptions fade-in delay"
            dangerouslySetInnerHTML={{ __html: description }}>
          </div>
        </Readmore>
      )}

      { amenities && (
        <Amenities useAmenities={useAmenities} amenities={amenities} />
      )}

      { actions }

    </InfoPanelContent>
  )
}

export default WaypointInfo
